import { openPopup, closePopups } from '../helpers/popupHelpers';

const popups = () => {
	const popups = document.querySelectorAll('.js-popup');
	if (popups.length > 0) {
		// Close popup
		popups.forEach((popup) => {
			popup.querySelectorAll('.js-close-popup').forEach((el) => {
				el.addEventListener('click', () => closePopups());
			});
		});

		// Open popup
		const triggers = document.querySelectorAll('.js-open-popup');
		triggers.forEach((trigger) => {
			if (!trigger.hasAttribute('data-popup')) return false;

			trigger.addEventListener('click', (e) => {
				e.preventDefault();

				const popupId = trigger.getAttribute('data-popup');
				openPopup(popupId);
			});
		});

		// Show small popup on scroll
		const smallPopup = document.querySelector('.js-custom-popup');
		const smallPopupId = smallPopup.getAttribute('data-popup');
		const smallPopupPersistence = smallPopup.getAttribute('data-persistence');
		let hasOpened = false;
		if (smallPopup) {
			window.addEventListener('scroll', e => {
				if (!hasOpened && window.scrollY > window.outerHeight * 1.5) {
					if (smallPopupPersistence === 'always') {
						openPopup(smallPopupId);
						hasOpened = true;
					} else if (smallPopupPersistence === 'once' && localStorage.getItem(`popup-${smallPopupId}`) !== 'opened') {
						openPopup(smallPopupId);
						hasOpened = true;
					}
				}
			})
		}
	}
};

popups();
